"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

require("core-js/modules/es6.array.slice.js");

require("core-js/modules/es6.array.map.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Item = _interopRequireDefault(require("./Item"));

var _style = require("./style");

var _excluded = ["dataSource", "col", "customTitleWidth"];

var _this = void 0;

var itemShape = {
  /**
   * 配置项标题
   */
  title: _propTypes["default"].node,

  /**
   * 配置项标题的解释内容
   */
  titleTip: _propTypes["default"].node,

  /**
   * 配置项的内容
   */
  content: _propTypes["default"].node,

  /**
   * 配置项的其他信息，如操作、补充信息等
   */
  extra: _propTypes["default"].node
};
/**
 * ConfigInfo
 * @description 展示配置信息
 */

var ConfigInfo = function ConfigInfo(_ref) {
  var _this2 = this;

  (0, _newArrowCheck2["default"])(this, _this);
  var dataSource = _ref.dataSource,
      col = _ref.col,
      customTitleWidth = _ref.customTitleWidth,
      others = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var len = dataSource.length;

  if (col > 1) {
    var groupedData = [];
    var lineNum = Math.ceil(len / col);

    for (var i = 0; i < lineNum; i++) {
      groupedData.push(dataSource.slice(i * col, i * col + col));
    }

    var groupedDataLen = groupedData.length;
    return /*#__PURE__*/_react["default"].createElement(_style.StyledOuterWrapper, others, /*#__PURE__*/_react["default"].createElement(_style.StyledWrapper, {
      col: col
    }, groupedData.map(function (items, i) {
      var _this3 = this;

      (0, _newArrowCheck2["default"])(this, _this2);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style.itemWrapperInnerCls,
        key: i
      }, items.map(function (item, j) {
        (0, _newArrowCheck2["default"])(this, _this3);
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(_style.itemWrapperCls, " ").concat(i + 1 === groupedDataLen ? _style.itemWrapperNoBottomCls : ""),
          key: j
        }, /*#__PURE__*/_react["default"].createElement(_Item["default"], (0, _extends2["default"])({}, item, {
          customTitleWidth: customTitleWidth
        })));
      }.bind(this)));
    }.bind(this))));
  }

  return /*#__PURE__*/_react["default"].createElement("div", others, dataSource.map(function (item, i) {
    (0, _newArrowCheck2["default"])(this, _this2);
    return /*#__PURE__*/_react["default"].createElement(_Item["default"], (0, _extends2["default"])({
      key: i
    }, item, {
      customTitleWidth: customTitleWidth,
      withBorder: i + 1 === len ? false : true
    }));
  }.bind(this)));
}.bind(void 0);

ConfigInfo.propTypes = {
  /**
   * 配置项数据数组
   */
  dataSource: _propTypes["default"].arrayOf(_propTypes["default"].shape(itemShape)),

  /**
   * 多列展示的列数
   */
  col: _propTypes["default"].oneOf([1, 2, 3, 4]),

  /**
   * 自定义标题的宽度，字符串要带"px"，如100或100px
   */
  customTitleWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

  /** @ignore */
  className: _propTypes["default"].string
};
ConfigInfo.defaultProps = {
  dataSource: [],
  col: 1
};
var _default = ConfigInfo;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/ConfigInfo/ConfigInfo.js
// module id = 2093
// module chunks = 6 7 17 18